/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Workout_Long_RunInputs */

const en_coach_workout_long_run = /** @type {(inputs: Coach_Workout_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`90min Long Run`)
};

const de_coach_workout_long_run = /** @type {(inputs: Coach_Workout_Long_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`90min Dauerlauf`)
};

/**
* | output |
* | --- |
* | "90min Long Run" |
*
* @param {Coach_Workout_Long_RunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_workout_long_run = /** @type {((inputs?: Coach_Workout_Long_RunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Workout_Long_RunInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_workout_long_run(inputs)
	return de_coach_workout_long_run(inputs)
});